export const truncateText = (text: string, maxLength: number) => {
  return text && text.length > maxLength
    ? text.substring(0, maxLength) + "..."
    : text;
};

/**
 * Extract email address from format "Name <email@example.com>"
 * @param email - Email string, possibly with name prefix
 * @returns Just the email address
 */
export const getSenderEmail = (email: string): string => {
  if (!email) return "";
  const match = /<(.+?)>/.exec(email);
  return match ? match[1] : email;
};

/**
 * Extract sender name from format "Name <email@example.com>"
 * @param sender - Sender string with name and possibly email
 * @returns Just the name portion
 */
export const getSenderName = (sender: string): string => {
  if (!sender) return "";
  const match = /^([^<]+)/.exec(sender);
  return match ? match[1].trim() : sender;
};

export function statusColor(color: string) {
  if (!color || color === "0") return "";
  try {
    let finalColor = (+color).toString(16).split("").reverse();
    let padding = Array(6 - finalColor?.length).fill("0");
    let finalColorString = "#" + [...finalColor, ...padding].join("");
    return finalColorString === "#ffffff" ? "#FAFAFA" : finalColorString;
  } catch (error) {
    return "";
  }
}

export const formatDecimalToString = (amount: any) => {
  // Check if the amount is null or undefined
  if (amount === null || amount === undefined) {
    return "0";
  }
  // Check if the amount is a number, if not convert it to string
  if (typeof amount !== "string") {
    amount = amount.toString();
  }

  // Check if the amount ends with '.00'
  if (amount?.endsWith(".00")) {
    // If yes, remove the decimal part
    return amount.substring(0, amount.length - 3);
  }
  // If the decimal part is not '.00', return the original amount
  return amount;
};

export const joinPaths = (...paths: string[]): string => {
  return paths.join("/").replace(/\/+/g, "/");
};

export const isBase64 = (str: string): boolean => {
  if (!str || typeof str !== "string") return false;

  const s = str.replace(/\s/g, "");

  return /^[A-Za-z0-9+/]+={0,2}$/.test(s);
};

export const toBase64Unicode = (str: string): string => {
  return btoa(
    encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (_, p1) =>
      String.fromCharCode(parseInt(p1, 16))
    )
  );
};

export const fromBase64Unicode = (str: string): string => {
  try {
    if (!isBase64(str)) return str;

    return decodeURIComponent(
      Array.prototype.map
        .call(
          atob(str),
          (c: string) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0")
        )
        .join("")
    );
  } catch {
    return str;
  }
};

export function normalizeText(s: string) {
  return (s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();
}

export const CLOSED_TITLES = new Set([
  "closed",
  "uzavren", // Uzavřen
  "uzavreno",
  "geschlossen",
  "ferme",
  "cerrado",
  "chiuso",
  "zakryto",
  "مغلق",
]);
